import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { lockSiteName } from "./utils/siteTitle";
import { initTranslation } from "./utils/translate";
lockSiteName();
initTranslation();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-328" data-mp="26a29x6dc25no" />);
}